import './LoadingContentDiv.scss';

export default function LoadingContentDiv({ width = 300, offset = 0 }: { width?: number, offset?: number }) {
  return (
    <div data-component="LoadingContentDiv" style={{ width, marginLeft: offset }}>
    </div>
  );
}
